import { Container, Row, Col } from "reactstrap";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import "./CourseRecommendations.css";

const CourseRecommendations = ({
    courses = [],
}) => {

    if (!courses || courses.length === 0) {
        return null;
    }

    return (
        <section className="course-recommendations-section">

            <Container fluid>

                {/* =========================================
                    HEADER
                ========================================= */}

                <div className="course-recommendations-header">

                    <div className="course-recommendations-more">
                        More <strong>Courses</strong>
                    </div>

                    <h2>
                        YOU MIGHT ALSO{" "}
                        <strong>BE INTERESTED</strong>{" "}
                        IN THESE
                        <br />
                        COURSES
                    </h2>

                </div>


                {/* =========================================
                    COURSE GRID
                ========================================= */}

                <Row className="course-recommendations-row">

                    {courses.map((course, index) => (

                        <Col
                            lg="6"
                            md="6"
                            sm="12"
                            key={course.id || index}
                        >

                            <div className="recommended-course">

                                {/* Course Tab */}
                                <div className="recommended-course-tab">
                                    COURSE {index + 1}
                                </div>


                                {/* Card */}
                                <div className="recommended-course-body">

                                    {/* Main Content */}
                                    <div className="recommended-course-main">

                                        <h3>
                                            {course.title}
                                        </h3>

                                        <p className="recommended-course-description">
                                            {course.description}
                                        </p>

                                    </div>


                                    {/* =================================
                                        HOVER OVERLAY
                                    ================================= */}

                                    <div className="recommended-course-hover">

                                        <div className="course-hover-line" />

                                        <a
                                            href={course.url}
                                            className="recommended-course-link"
                                        >
                                            {course.linkTitle || course.title}
                                        </a>


                                        <div className="recommended-course-meta">

                                            <span>
                                                <MenuBookIcon />
                                                {course.lessons} lessons
                                            </span>

                                            <span>
                                                <AccessTimeIcon />
                                                {course.duration}
                                            </span>

                                        </div>


                                        <a
                                            href={course.url}
                                            className="recommended-view-course"
                                        >
                                            <span>
                                                View Course
                                            </span>

                                            <ArrowForwardIcon />
                                        </a>

                                    </div>

                                </div>

                            </div>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
};

export default CourseRecommendations;